module.exports = __webpack_public_path__ + "img/benefit_rams-vip-for-a-day.07588e73.jpg";